import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = {
  class: "menu menu-sub menu-sub-dropdown w-400px w-md-400px",
  "data-kt-menu": "true"
}
const _hoisted_9 = { class: "px-7 py-5" }
const _hoisted_10 = { class: "fs-5 text-dark fw-bold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_12 = { class: "px-7 py-5" }
const _hoisted_13 = { class: "form-label mb-3" }
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = { class: "px-7 pb-5" }
const _hoisted_16 = { class: "form-label mb-3" }
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tabla.serviciosSolicitadosListado.titulo")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("tabla.serviciosSolicitadosListado.numeroServicios", {
              numero: _ctx.serviciosListado?.length ?? 0,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _mergeProps({
          type: "button",
          class: "btn btn-light-primary position-relative me-5"
        }, _ctx.$attrs, {
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": "bottom-end",
          "data-kt-menu-flip": "top-end"
        }), [
          _createElementVNode("span", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default"),
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("grids.filterButton")) + " ", 1),
          (
              (_ctx.localidad !== undefined && _ctx.localidad !== '') ||
              (_ctx.filtroFechas !== undefined &&
                _ctx.filtroFechas !== null &&
                _ctx.filtroFechas !== '')
            )
            ? (_openBlock(), _createBlock(_component_el_badge, {
                key: 0,
                "is-dot": ""
              }))
            : _createCommentVNode("", true)
        ], 16),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("grids.filter.header")), 1)
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("tabla.familiasListado.filtro.municipio")) + ": ", 1),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.localidad,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localidad) = $event)),
                name: "localidad",
                filterable: "",
                placeholder: _ctx.$t('OpcionInicialLocalidad'),
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    disabled: "",
                    value: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("OpcionInicialLocalidad")), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipiosComarca, (municipio, i) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: i,
                      value: municipio.municipioNombre,
                      class: _normalizeClass({
                    'bg-light-primary': _ctx.localidad === municipio.municipioNombre,
                  })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(municipio.municipioNombre), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "localidad",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("tabla.familiasListado.filtro.fechaInscripcion")) + ": ", 1),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filtroFechas,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtroFechas) = $event)),
                name: "filtroFechas",
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": 
                  _ctx.$t('tabla.familiasListado.filtro.fechaInicio')
                ,
                "end-placeholder": _ctx.$t('tabla.familiasListado.filtro.fechaFin'),
                clearable: "",
                format: 'DD-MM-YYYY'
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "filtroFechas",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ])
        ]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
          style: {"width":"300px"},
          placeholder: _ctx.$t('tabla.buscador.placeholder')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_download_excel, {
          data: _ctx.serviciosListado,
          labels: _ctx.csvLabels,
          fields: _ctx.csvFields,
          name: _ctx.csvName
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_18, [
              _createElementVNode("i", {
                class: "fas fa-file-excel fs-3",
                title: _ctx.$t('tabla.serviciosSolicitadosListado.boton.imprimir')
              }, null, 8, _hoisted_19)
            ])
          ]),
          _: 1
        }, 8, ["data", "labels", "fields", "name"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_el_table, {
        "row-class-name": _ctx.tableRowClassName,
        data: _ctx.result,
        style: {"width":"100%"},
        "default-sort": { prop: 'createdOn', order: 'descending' },
        onSortChange: _ctx.sortChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "tipoServicio",
            align: "center",
            width: "50"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("i", {
                class: _normalizeClass(
                scope.row.tipoServicio == 'SERVICIO_INDIVIDUAL'
                  ? 'fas fa-user ms-2 fs-3'
                  : 'fas fa-users ms-2 fs-3'
              )
              }, null, 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.familias.cabecera.fecha'),
            prop: "createdOn",
            formatter: _ctx.toLocaleDateString,
            sortable: "",
            width: "110"
          }, null, 8, ["label", "formatter"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.familias.cabecera.nombreServicio'),
            prop: "nombreServicio",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: _ctx.$t('tabla.familias.cabecera.comarca'),
                prop: "nombreComarca",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosSolicitadosListado.cabecera.responsable'),
            prop: "responsable",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosSolicitadosListado.cabecera.dni'),
            prop: "dni",
            sortable: "",
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosSolicitadosListado.cabecera.telefono'),
            prop: "telefono",
            sortable: "",
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosPrestadosListado.cabecera.localidad'),
            prop: "localidad",
            sortable: "",
            width: "100"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosPrestadosListado.cabecera.menores'),
            prop: "menores",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.serviciosSolicitadosListado.cabecera.ingresos'),
            sortable: "",
            "sort-method": _ctx.sortIngresos,
            width: "100",
            align: "right"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.conIngresos ? scope.row.ingresos + "€" : "0€"), 1)
            ]),
            _: 1
          }, 8, ["label", "sort-method"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosSolicitadosListado.cabecera.familiaPrioritaria')
          ,
            prop: "familiaPrioritaria",
            sortable: "",
            align: "center",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("i", {
                class: _normalizeClass(
                scope.row.familiaPrioritaria == true
                  ? 'fas fa-check ms-2 fs-3'
                  : 'fas fa-times ms-2 fs-3'
              )
              }, null, 2)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.familias.cabecera.estado'),
            sortable: "",
            width: "130",
            "sort-method": _ctx.sortEstado,
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                class: "ml-2",
                type: 
                scope.row.estado == 'INCORPORADO'
                  ? 'success'
                  : scope.row.estado == 'LISTA_DE_ESPERA'
                  ? 'warning'
                  : scope.row.estado == 'REALIZADO_POR_ERRROR' ||
                    scope.row.estado == 'RECHAZADO'
                  ? 'danger'
                  : ''
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("estados." + scope.row.estado)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label", "sort-method"]),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            width: "50"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "text",
                onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosSolicitadosListado.fila.ver")), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["row-class-name", "data", "onSortChange"]),
      _createVNode(_component_el_pagination, {
        class: "my-5 float-end",
        background: "",
        "page-size": 100,
        layout: "prev, pager, next",
        total: _ctx.serviciosListado.length,
        "hide-on-single-page": true,
        "current-page": _ctx.currentPage,
        onCurrentChange: _ctx.handleCurrentPageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])
    ])
  ]))
}